<app-navigation-button
  (click)="click()"
  [href]="href"
  [hasEmit]="hasEmit"
  [size]="vtmnButtonSize.STRETCHED"
  [variant]="vtmnButtonVariant.TERTIARY"
  buttonClass="my-1"
>
  <div class="flex items-center w-full">
    <!-- Image -->
    <img class="w-8 h-8 rounded rounded-bl-none mr-3" [src]="image" alt="" />

    <div
      class="horizontal-card__text-container text-grey-dark-3 w-full text-left"
    >
      <!-- Title -->
      <h3 class="title-3">{{ title }}</h3>

      <!-- Description -->
      <p class="truncate font-normal">{{ description }}</p>
    </div>
  </div>
</app-navigation-button>
